import { replace } from 'svelte-spa-router';
import Login from '../components/pages/Login.svelte';
import Home from '../components/pages/Home.svelte';
import Project from '../components/pages/Project.svelte';
import Report from '../components/pages/Report.svelte';
import NotFound from '../components/pages/NotFound.svelte';
import { addAuthGuard } from './router.helpers';
import '../modules/auth/auth.resource';
import authService from '../modules/auth/auth.service';
export const routes = addAuthGuard({
    '/login': Login,
    '/': Home,
    '/project/:project': Project,
    '/project/:project/*': Project,
    '/report/:project/:reportDate': Report,
    '/report/:project/:reportDate/*': Report,
    '*': NotFound,
});
export async function onRouteConditionsFailed() {
    try {
        await authService.logout();
    }
    catch (error) { }
    replace('/login');
}
